import { SegmentPageTemplate } from 'src/components/pages/segment/SegmentPageTemplate';

import { useReduceDeforestationConfig } from './ReduceDeforestationConfig';

export const ReduceDeforestationPage = () => {
  const { isBundleLoading, config } = useReduceDeforestationConfig();

  return (
    <SegmentPageTemplate config={config} isBundleLoading={isBundleLoading} breadcrumbTitle={config?.heroAsset?.title} />
  );
};
